import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement> {
  /** Tailwind size classes are usually passed via className (e.g. `h-4 w-32`). */
  rounded?: 'md' | 'lg' | 'xl' | '2xl' | 'full';
}

const radius: Record<NonNullable<SkeletonProps['rounded']>, string> = {
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  full: 'rounded-full',
};

/** Shimmering placeholder for loading states. */
export function Skeleton({ rounded = 'lg', className, ...rest }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={cn('ts-shimmer bg-surface-subtle', radius[rounded], className)}
      {...rest}
    />
  );
}
